import React from 'react'
import { Document, Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";

export default function SituacionRiesgoTablaXl({ columns, data }) {

// 📌 Estilos para la tabla
const styles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 10,
    },
    table: {
      display: "table",
      width: "100%",
      borderStyle: "solid",
    //   borderWidth: 1,
      borderColor: "#000",
      // borderLeftWidth: 0.5,
    },
    tableRowHeader: {
      flexDirection: "row",
      backgroundColor: "#c31e64",
      color: "#fff",
      textAlign: "center",
      fontSize: 10,
      marginBottom:2
    },
    tableRow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderColor: "#000",
    },
    //  Sin separación entre bloques del MISMO riesgo (continuaciones), para que
    //  se vean como un único riesgo continuo.
    tableRowCont: {
      borderBottomWidth: 0,
    },
    tableColHeader: {
      flex: 1,
      borderStyle: "solid",
      borderWidth: 0.5,
      borderColor: "#000",
      padding: 5,
      fontWeight: "bold",
      textAlign: "center",
    },
    tableCol: {
      flex: 1,
      borderStyle: "solid",
    // //   borderWidth: 0.5,
      borderColor: "#000",
      borderLeftWidth: 0.3,
      borderRightWidth: 0.5,
      padding: 5,
      fontSize: 8,
    },
    image: {
      width: 40,
      height: 38,
      marginTop: 8,
      marginLeft:35,
      objectFit: "contain",
    },
    fincaText: {
      fontSize: 8,
      marginBottom: 2,
    },
  });

  //  Máximo de fincas por bloque. Bloques pequeños reducen el hueco en blanco que
  //  deja "wrap={false}" cuando un bloque no cabe en lo que resta de página.
  const CHUNK_SIZE = 12;

  //  Trocea cada riesgo en varios bloques cuando su lista de fincas es muy larga.
  //  Solo el primer bloque muestra nombre/origen/medidas/img; los siguientes
  //  dejan esas columnas vacías y continúan la lista de fincas, para que se vea
  //  como un único riesgo y no como varios distintos.
  const rows = data.flatMap((item) => {
    const fincas = Array.isArray(item.fincas) ? item.fincas : [];
    if (fincas.length <= CHUNK_SIZE) {
      return [item];
    }
    const chunks = [];
    for (let i = 0; i < fincas.length; i += CHUNK_SIZE) {
      const isFirst = i === 0;
      chunks.push({
        ...item,
        riesgo: isFirst ? item.riesgo : "",
        origen: isFirst ? item.origen : "",
        medidas: isFirst ? item.medidas : [],
        img: isFirst ? item.img : null,
        fincas: fincas.slice(i, i + CHUNK_SIZE),
        //  Marca los bloques que son continuación del mismo riesgo para no
        //  dibujar la línea de separación entre ellos.
        isCont: !isFirst,
      });
    }
    return chunks;
  });

  return (
    <View style={styles.table}>
    {/*  Encabezado de la Tabla */}
    <View style={styles.tableRowHeader} fixed >
      {columns.map((col, index) => (
        <Text key={index} style={styles.tableColHeader}>{col.value}</Text>
      ))}
    </View>

    {/*  Filas de Datos */}
    {rows.map((item, rowIndex) => {
      //  Si el siguiente bloque es continuación del mismo riesgo, usamos una
      //  línea tenue en vez de la separación fuerte entre riesgos distintos.
      const nextIsCont = rows[rowIndex + 1]?.isCont;
      return (
      <View
        key={rowIndex}
        style={[styles.tableRow, nextIsCont && styles.tableRowCont]}
        wrap={false}
      >
        {columns.map((col, colIndex) => (
          <View key={colIndex} style={styles.tableCol}>
            {/*  Renderiza el campo normal */}
            {col.key !== "medidas" && col.key !== "img" && col.key !== "fincas" && (
              <Text>{Array.isArray(item[col.key]) ? item[col.key].join(", ") : item[col.key]}</Text>
            )}

            {/*  Renderiza medidas y la imagen en la misma celda */}
            {col.key === "medidas" && (
              <>
                {(item.medidas || []).map((medida, medidaIndex) => (
                  <Text key={medidaIndex}>{medida}</Text>
                ))}
                {item.img && <Image src={item.img} style={styles.image} />}
              </>
            )}

            {/*  Renderiza el array de fincas con cada elemento en una línea */}
            {col.key === "fincas" && item.fincas.map((finca, fincaIndex) => (
              <Text key={fincaIndex} style={styles.fincaText}>{finca}</Text>
            ))}
          </View>
        ))}
      </View>
      );
    })}
  </View>
  )
}
